import React from 'react';

import formatter from '../../utilities/formatter';

const ChangeLogItem = ({ item }) => {

    return (
        <tr>
            <td style={{ height: '20px', width: '120px' }}>
                <div className="d-flex">
                    <span>{formatter.dateChangeLogFormat(item.date)}</span>
                    <span style={{ textAlign: 'right', flexGrow: '1', paddingRight:'5px' }}>{formatter.timeChangeLogFormat(item.date)}</span>
                </div>
            </td>
            <td style={{ height: '20px', textAlign:'center' }}>{`${item.entityName} ${item.userAction}`}</td>
            <td style={{ height: '20px', width: '35px', textAlign: 'right' }} >{item.userInitials}</td>
        </tr>
    );
}

export default ChangeLogItem;